<ng-template #loadingCircle>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<div style="display: inline-flex; flex-wrap: wrap; align-items: center">
    <input #searchingText
           (input)="sortTasks(board, true, searchingText.value)"
           class="form-control form-control-sm"
           data-action="sortTasksByInput"
           placeholder="{{ 'BUTTON_TEXT.SEARCH' | translate }}"
           style="width: auto; min-width: 220px"
           type="text"
    >
    <span *ngIf="!isLoading else refresh"></span>

    <div *ngIf="sortParamsGroup"
         class="flex-display">
        <span class="ms-3">{{ 'TASKS.COLUMN.SORT.SORT' | translate }}:</span>
        <select #sortParams
                (change)="changeSortParams(sortParams.value, sortParamsGroup.type)"
                class="form-select form-select-sm ms-1"
                style="width: 200px">
            <option [selected]="sortParamsGroup.key === 'task_alias'"
                    value="task_alias">{{ 'TASKS.COLUMN.SORT.ALIAS' | translate }}
            </option>
            <option [selected]="sortParamsGroup.key === 'importance_index'"
                    value="importance_index">{{ 'TASKS.COLUMN.SORT.INDEX' | translate }}
            </option>
            <option [selected]="sortParamsGroup.key === 'importance'"
                    value="importance">{{ 'TASKS.COLUMN.SORT.IMPORTANCE' | translate }}
            </option>
            <option [selected]="sortParamsGroup.key === 'created_at'"
                    value="created_at">{{ 'TASKS.COLUMN.SORT.CREATED_AT' | translate }}
            </option>
            <option [selected]="sortParamsGroup.key === 'deadline_at'"
                    value="deadline_at">{{ 'TASKS.COLUMN.SORT.DEADLINE' | translate }}
            </option>
            <option [selected]="sortParamsGroup.key === 'updated_at'"
                    value="updated_at">{{ 'TASKS.COLUMN.SORT.UPDATED_AT' | translate }}
            </option>
        </select>
        <i (click)="changeSortParams(sortParamsGroup.key, sortParamsGroup.type === 'asc' ? 'desc' : 'asc')"
           [ngClass]="sortParamsGroup.type === 'asc' ? 'bi bi-sort-alpha-down' : 'bi bi-sort-alpha-up'"
           class="ms-1 text-success"
           style="cursor: pointer"
        ></i>
    </div>
</div>

<div *ngIf="taskTypes && statusesWithTask.length"
     class="mt-2"
     style="max-width: 800px">
    <span *ngFor="let type of taskTypes; let i = index">
        <span (click)="filterByTaskTypeInBoard(type)"
              *ngIf="i <= 3"
              [attr.data-type-hidden]="type.isHidden"
              [attr.data-type-index]="i"
              [attr.data-type-name]="type.name"
              [ngbTooltip]="type.name"
              class="badge badge-pill hidden_text me-1 {{type.isHidden ? 'text-bg-light' : 'text-bg-info'}}"
              data-action="sortTasksByType"
        >
            <i [class]="type.icon"></i>
            {{ !type.key ? type.name : 'TASKS.COLUMN.MY_TASKS' | translate }}
        </span>
    </span>

    <div style="display: inline-block">
        <span #filterButtonShowContainer
              *ngIf="taskTypes.length > 4"
              class="badge badge-pill hidden_text text-bg-success"
              data-action="openMoreTaskTypes"
        >
	 	    {{ 'TASKS.COLUMN.MORE' | translate }}...
	    </span>

        <div #filterContainer
             *ngIf="showMoreTaskTypes"
             class="filter-container gbo_shadow">
            <span *ngFor="let type of taskTypes; let i = index">
                <span (click)="filterByTaskTypeInBoard(type)"
                      *ngIf="i >= 4"
                      [attr.data-type-hidden]="type.isHidden"
                      [attr.data-type-index]="i"
                      [attr.data-type-name]="type.name"
                      [ngbTooltip]="type.name"
                      class="badge badge-pill me-1 mt-1 hidden_text {{type.isHidden ? 'text-bg-light' : 'text-bg-info'}}"
                      data-action="sortTasksByType"
                >
                    <i [class]="type.icon"></i>
                    {{ type.name }}
                </span>
            </span>
        </div>
    </div>
</div>

<div *ngIf="!loading else loadingCircle"
     cdkDropListGroup
     cdkScrollable
     style="overflow: auto; height: calc(100vh - 220px)"
>
    <div *ngIf="statusesWithTask.length"
         class="column">
        <div (cdkDropListDropped)="drop($event)"
             *ngFor="let status of statusesWithTask; let i = index"
             [attr.data-column-index]="i"
             [attr.data-status-name]="status.label"
             [cdkDropListData]="status"
             [class.disabled]="status.canDrop"
             [style]="'width: ' + columnSize + 'px;'"
             cdkDropList
             class="example-container gbo_shadow">
            <div [style]="'margin-bottom: 10px; ' +
                            'padding: 5px;' +
                            'border: 2px solid lightgray;' +
                            'align-items: baseline;' +
                            'display: flex;' +
                            'background:' + status.data.backgrCol"
            >
                <i [class]="status.data.svg.class"></i>
                <strong style="font-size: 16px; margin-left: 10px">{{ status.label }}</strong>
                <span class="badge text-bg-info"
                      style="margin-left: 10px">{{ status.tasks.length }}</span>
                <i *ngIf="status.is_successful"
                   class="bi bi-bookmark-check"
                   style="color: blue; margin-left: 10px;"
                   title="{{ 'TASKS.COLUMN.STATUSES.SUCCESSFUL' | translate }}"></i>
                <i *ngIf="status.is_universal"
                   class="bi bi-arrows-angle-contract"
                   style="margin-left: 10px"
                   title="{{ 'TASKS.COLUMN.STATUSES.UNIVERSAL' | translate }}"></i>
                <i *ngIf="status.to_archive"
                   class="bi bi-archive"
                   style="margin-left: 10px"
                   title="{{ 'TASKS.COLUMN.STATUSES.ARCHIVE' | translate }}"></i>
                <i *ngIf="status.is_initial"
                   class="bi bi-arrow-bar-right"
                   style="margin-left: 10px"
                   title="{{ 'TASKS.COLUMN.STATUSES.INITIAL' | translate }}"></i>
            </div>
            <div (cdkDragStarted)="update($event)"
                 (click)="goToTask(task)"
                 *ngFor="let task of status.tasks; let it = index"
                 [attr.data-index-task]="it"
                 [cdkDragData]="task"
                 [cdkDragStartDelay]="100"
                 [ngClass]="getClass(task)"
                 cdkDrag
                 class="example-list"
                 data-action="openTask">
                <div class="example-box"
                     id="'#' + {{task.task_alias}}">
                    <span style="font-size: 14px; word-break: break-word">
                        <i [class]="task.task_type.icon"
                           [title]="task.task_type.name"
                        ></i>
                        <strong> #{{ task.task_alias }} </strong>
                        {{ task.title }}
                    </span>
                    <span *ngIf="!!task.comments_count"
                          [title]="('TASKS.COLUMN.COMMENTS' | translate) + ': ' + task.comments_count "
                          class="badge badge-pill text-bg-secondary pill"
                    >
                        {{ task.comments_count }}
                    </span>
                </div>
            </div>
            <div *ngIf="!status.tasks.length"
                 style="display: block; text-align: center;">
                <small>{{ 'EMPTY_LISTS.TASKS' | translate }}</small>
            </div>
        </div>
    </div>
    <div *ngIf="!statusesWithTask.length"
         class="column">
        {{ 'EMPTY_LISTS.STATUSES' | translate }}
    </div>
</div>

<ng-template #taskView
             let-modal>
    <app-button-modal-close (closeEmit)="closeModal(false)"
                            [modal]="modal"
                            modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-task-detail
                (emitOnDelete)="$event ? closeModal(true, modal) : null"
                (emitUpdateStatus)="loadTasks()"
                (emitUpdateTask)="loadTasks(true)"
                [board]="board"
                [taskAlias]="taskId"
        ></app-component-task-detail>
    </div>
</ng-template>
